class c extends HTMLElement {
  constructor() {
    super(), this.page = 1, this.sectionId = this.getAttribute("section-id") || "", this.pageURL = this.getAttribute("page-url") || "", this.gridSelector = this.getAttribute("grid-selector") || "", this.nextPage = parseInt(this.getAttribute("next-page") || "1", 10), this.page = parseInt(this.getAttribute("page") || "1", 10), this.init(), this.onLoadMore = this.onLoadMore.bind(this);
  }
  init() {
    this.addEventListener("click", this.onLoadMore), !window.location.pathname.includes("search") && this.manualLoadMore();
  }
  async onLoadMore(t) {
    t.preventDefault();
    const i = t.target;
    if (!i) return;
    const e = i.hasAttribute("load-more") ? i : i.closest("a");
    e && (e.setAttribute("aria-disabled", "true"), this.fetchGrid(), this.nextPage !== 2 && this.updateURLHash(this.pageURL));
  }
  fetchGrid() {
    const t = `${this.pageURL}`;
    fetch(t).then((i) => {
      i.ok && i.text().then((e) => {
        const r = new DOMParser().parseFromString(e, "text/html"), a = r.querySelector("[product-grid]"), n = document.querySelector(this.gridSelector);
        n && a && this.appendProductsCardsToGrid(n, a);
        const o = document.querySelector("collection-paginate"), s = r.querySelector("collection-paginate");
        o && s && o.replaceWith(s);
      });
    });
  }
  appendProductsCardsToGrid(t, i) {
    const e = i.children;
    if (e) {
      let r = !1;
      for (; e.length; ) {
        r = !1;
        for (let a = 0; a < t.children.length; a++)
          (t.children[a].getAttribute("data-key") === e[0].getAttribute("data-key") || !e[0].hasAttribute("data-key")) && (r = !0);
        r ? e[0].remove() : t.appendChild(e[0]);
      }
    }
  }
  updateURLHash(t) {
    history.replaceState({ page: this.page }, "", t);
  }
  manualLoadMore() {
    const t = this.querySelector("button[load-more]");
    setTimeout(() => {
      t.click();
    }, 300);
  }
}
window.customElements.define("collection-paginate", c);
export {
  c as CollectionPaginate
};
